<app-skill-builder-text-box
	[title]="page.title"
	[value]="data.idea"
	[errorRequired]="page.errorRequired"
	[disclaimer]="disclaimer"
	[next]="next"
></app-skill-builder-text-box>
